import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ABOUT = (
    <FormattedMessage
        id='about'
        defaultMessage='О событии'
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXWrapper/translations.jsx